// extracted by mini-css-extract-plugin
export default {"legendContainer":"Legend_legendContainer__KCvZ7","legendItem":"Legend_legendItem__Ujv8M","legendDot":"Legend_legendDot__MT15o"};